import styled from 'styled-components';
import { URL_REGEX } from '../../../constants';
import type { BlockProps } from '../../lib/card';
import { CardLayout } from '../../lib/card';
import { PreviewLink } from '../components';
import { usePost } from '../Post';
import { useMedia, usePostSettings } from '../utils';

export function CardPreviewLinkBlock(forwardingProps: BlockProps) {
  const { heightNormalization } = usePostSettings();
  const { textLink } = usePost();
  const media = useMedia();
  const [mediaLink = ''] = media?.url?.match(URL_REGEX) ?? [];

  const link = textLink || mediaLink;

  if (!link) {
    return null;
  }

  return (
    <PreviewLinkBlock
      {...forwardingProps}
      _heightNormalization={heightNormalization}
    >
      <PreviewLink link={link} media={media} />
    </PreviewLinkBlock>
  );
}

const PreviewLinkBlock = styled(CardLayout.PreviewLinkBlock)<{
  _heightNormalization: boolean;
}>`
  ${({ _heightNormalization }) =>
    _heightNormalization && 'margin-bottom: auto'};
`;
